module.exports = __webpack_public_path__ + "img/67_6.8cb8b847.png";